module.exports = __webpack_public_path__ + "static/img/download-title-text.c4f71cbc.jpg";